import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

// ProgressFilterTab.js
export const ProgressFilterTab = ({ onChange, onKeyDown, onClear, progressFilter, classes }) => {
  return (
    <Box className={classes.filterContainer}>
      <Typography variant="subtitle1" className={classes.progressText}>
        Progress
      </Typography>

      {/* <img
        src="/assets/images/is_equal_to_or_greater_than_symbol.svg"
        alt="greater than"
        className={classes.progressIcon}
      /> */}

      <Box className={classes.inputContainer}>
        <TextField
          variant="outlined"
          placeholder="Enter %"
          size="small"
          type="number"
          value={progressFilter}
          onChange={onChange}
          onKeyDown={onKeyDown}
          className={classes.textField}
          InputProps={{
            startAdornment: (
              <InputAdornment className={classes.startAdornment} position="start">
                ≥
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment className={classes.endAdornment} position="end">
                %
              </InputAdornment>
            ),
            inputProps: {
              min: 0,
              max: 100,
              style: { textAlign: 'right' },
            },
          }}
        />

        <IconButton size="small" className={classes.clearButton} disabled={!progressFilter} onClick={onClear}>
          <ClearIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};
